<!--*ngIf="!(isLoading$ | async) && (groups$ | async).length !== 0"-->
@if (!(isLoading$ | async) || (groups$ | async)?.length !== 0) {
  <div class="d-flex h-100 box-border pb-2">
    @if ((isLoading$ | async) && (groups$ | async)?.length !== 0) {
      <mat-progress-bar class="custom-loading-progress-bar" mode="indeterminate"></mat-progress-bar>
    }
    <ng-scrollbar #scrollbar class="std-scrollbar" orientation="vertical">
      <div [ngClass]="{ 'mr-3': scrollbar.isVerticallyScrollable() }">
        @for (group of groups$ | async; track group) {
          <app-discussions-list-item [group]="group"></app-discussions-list-item>
        }
      </div>
    </ng-scrollbar>
    @if ((groups$ | async)?.length === 0) {
      <div class="mt-4 text-center text-blue-700">No discussions.</div>
    }
  </div>
}
@if ((isLoading$ | async) && (groups$ | async)?.length === 0) {
  <div class="h-100 flex justify-center items-center">
    <span class="icon-refresh animate-spin pic-loading text-size_title_xl text-navy-600"></span>
  </div>
}
